var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30554 12.4215L11.999 19L18.6945 12.4215C19.1073 12.0241 19.4357 11.5475 19.66 11.0201C19.8844 10.4927 20 9.92542 20 9.35223C20 8.77904 19.8844 8.21175 19.66 7.68435C19.4357 7.15696 19.1073 6.68031 18.6945 6.28299C17.8622 5.46093 16.7399 5 15.5706 5C14.4012 5 13.2789 5.46093 12.4467 6.28299L11.999 6.72102L11.5513 6.28299C10.7194 5.46105 9.59744 5.00018 8.42842 5.00018C7.2594 5.00018 6.13744 5.46105 5.30554 6.28299C4.89272 6.68031 4.5643 7.15696 4.33997 7.68435C4.11563 8.21175 4 8.77904 4 9.35223C4 9.92542 4.11563 10.4927 4.33997 11.0201C4.5643 11.5475 4.89272 12.0241 5.30554 12.4215Z",
    fill: "#7B7B90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.33491a6adc6eef15479023412a2d2059.svg";
export { ForwardRef as ReactComponent };